import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((open) => !open);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="nav-outer sticky top-0 z-50 bg-black text-white shadow-md">
      <div className="nav-inner flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center justify-between gap-4">
          <div className="font-bold text-xl tracking-tight">
            <Link to="/" className="hover:text-gray-300" onClick={closeMenu}>
              Dalmo Mendonça
            </Link>
          </div>
          <button
            type="button"
            onClick={toggleMenu}
            className="inline-flex items-center justify-center gap-2 rounded-md border border-white/20 p-2 text-sm font-semibold uppercase tracking-[0.08em] transition hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/60 md:hidden"
            aria-expanded={menuOpen}
            aria-controls="primary-nav"
          >
            <span className="sr-only">Toggle navigation</span>
            <svg
              className="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              {menuOpen ? (
                <path
                  fillRule="evenodd"
                  d="M4.22 4.22a.75.75 0 011.06 0L10 8.94l4.72-4.72a.75.75 0 111.06 1.06L11.06 10l4.72 4.72a.75.75 0 11-1.06 1.06L10 11.06l-4.72 4.72a.75.75 0 11-1.06-1.06L8.94 10 4.22 5.28a.75.75 0 010-1.06z"
                  clipRule="evenodd"
                />
              ) : (
                <path d="M3.5 6.5A1.5 1.5 0 015 5h10a1.5 1.5 0 010 3H5a1.5 1.5 0 01-1.5-1.5zm0 7A1.5 1.5 0 015 12h10a1.5 1.5 0 010 3H5a1.5 1.5 0 01-1.5-1.5z" />
              )}
            </svg>
          </button>
        </div>
        <div
          id="primary-nav"
          className={`${
            menuOpen ? 'flex' : 'hidden'
          } flex-col gap-2 rounded-md bg-black/80 md:flex md:flex-row md:items-center md:gap-1 md:bg-transparent`}
        >
          <Link
            to="/portfolio"
            className="rounded-md px-3 py-2 text-sm font-medium hover:bg-white/10 hover:text-white md:px-4"
            onClick={closeMenu}
          >
            Portfolio
          </Link>
          <Link
            to="/help"
            className="rounded-md px-3 py-2 text-sm font-medium hover:bg-white/10 hover:text-white md:px-4"
            onClick={closeMenu}
          >
            Can I help you?
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
